import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';

@Injectable()
export class MwPlatformService {
  constructor(private platform: Platform) {}

  isDevice(): boolean {
    return this.platform.ANDROID || this.platform.IOS;
  }
}
